import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCompanyDetails } from 'modules/_common/api';

export const useQueryCompanyDetails = ({ enabled }: { enabled?: boolean }) => {
  return useQuery(QUERY_KEYS.SETTINGS_COMPANY_DETAILS, getCompanyDetails, { enabled });
};
